import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import "@usecapsule/react-sdk/styles.css";
import BgImage from "@/assets/bg.png";

const App = () => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#333",
        height: "100%",
      }}
    >
      <Outlet />
    </Box>
  );
};

export default App;
